// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueFormGenerator from 'vue-form-generator'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueFormWizard from 'vue-form-wizard'
import i18n from './i18n/dictionary'

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'

import VueSweetalert2 from 'vue-sweetalert2'
import SweetAlertIcons from 'vue-sweetalert-icons'
import 'sweetalert2/dist/sweetalert2.min.css'

import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import Verte from 'verte'
import 'verte/dist/verte.css'

import VueGallerySlideshow from 'vue-gallery-slideshow';

import store from './store'

// Api gates
import apiFetchingGate from './api_gates/fetch'

// constants
import tenants from './constants/tenants'
import visitStatuses from './constants/visitStatuses'
import unitMeasurements from './constants/unitMeasurements'
import visitServices from './constants/visitServices'
import patientAreas from './constants/patientAreas'
import visitRequiredFields from './constants/visitRequiredFields'

let VueAuth = require('@websanova/vue-auth')

Vue.component('verte', Verte)

Vue.config.productionTip = false
Vue.use(require('vue-moment'))

// Swiper
Vue.use(VueAwesomeSwiper)

// Axios
Vue.use(VueAxios, axios)

Vue.use(VueFormWizard)

// Sweet Alert
Vue.use(VueSweetalert2)
Vue.use(SweetAlertIcons)

let apiEndPoint = process.env.API_END_POINT
Vue.axios.defaults.baseURL = apiEndPoint
Vue.axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*'
Vue.router = router

Vue.use(VueAuth, {
  http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
  router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
  auth: require('@websanova/vue-auth/drivers/auth/devise.js'),
  loginData: { url: apiEndPoint + '/auth/sign_in', method: 'POST', redirect: '/' },
  authRedirect: { path: '/login' },
  logoutData: { url: apiEndPoint + '/auth/sign_out', method: 'DELETE', redirect: '/login', makeRequest: true },
  refreshData: { url: apiEndPoint + '/auth/validate_token', method: 'GET', enabled: true, interval: 8400 },
  fetchData: { url: apiEndPoint + '/auth/validate_token', method: 'GET', enabled: true },
  tokenExpired: () => { return false },
  tokenDefaultName: 'auth_token',
  rolesVar: 'role_name'
})

Vue.use(apiFetchingGate, { store: store, http: axios })

// constants
Vue.use(tenants)
Vue.use(visitStatuses)
Vue.use(unitMeasurements)
Vue.use(visitServices)
Vue.use(patientAreas)
Vue.use(visitRequiredFields)

Vue.use(VueGallerySlideshow)

window.pluralize = require('pluralize')
window.moment = require('moment-timezone')
window.moment.tz.setDefault('Africa/Cairo')
window._ = require('lodash')
window.echarts = require('echarts')

Vue.use(VueFormGenerator)

Vue.mixin(require('./mixins/global').default)
Vue.mixin(require('./mixins/search').default)
Vue.mixin(require('./constants/packageEntities').default)

global.router = router

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js